<template>
  <div :class="{ 'view-container': viewPage }">
    <div class="forms-wrapper services-mobile-position">
      <select-services
        :from="from"
        :service-changed="serviceChanged"
        :booking="booking"
        :currency="currency.currency_symbol"
        :view-page="viewPage"
      ></select-services>
    </div>

    <div class="col-md-12 text-center" v-if="isLoading">
      <img src="/pic/loading-4.gif" />
    </div>

    <div ref="services">
      <div
        v-for="(service, index) of services"
        :key="`${service.service_id}-${service.clone}`"
      >
        <service
          v-model="services[index]"
          :from="from"
          @serviceMounted="onServiceMounted"
          :bookingStatus="(booking || {}).bookingStatus"
          :companyId="companyId"
          :currency="currency"
          :date-format="dateFormat"
          :item-type="itemType"
          :item-id="itemId"
          :duplicate="duplicate"
          :loggedUser="loggedUser"
          :displayCopyDates="displayCopyDates"
          :time-format="timeFormat"
          :bookingStatuses="bookingStatuses"
          :tax-rates-options="taxRatesOptions"
        ></service>
      </div>

      <div
        class="ibox-content ibox-style mobile-service-ibox-content"
        style="border: none"
      >
        <select-services-dropdown
          style="margin-top: 25px"
          :from="from"
          :currency="currency.currency_symbol"
          v-if="
            !isMobile &&
            showUpperSelectServiceInput &&
            showUpperSelectServiceInput
          "
        ></select-services-dropdown>
      </div>
      <confirmation-popup
        title="Attention"
        message="The services that are incompatible with your chosen business type will be removed from your booking. Please confirm to proceed."
        id="confirmDeleteServiceModal"
        confirm-btn-text="Yes, remove not supported services"
        cancel-btn-text="No"
        @on-confirm="confirm_delete_unspported_services"
      >
      </confirmation-popup>
    </div>
  </div>
</template>

<script>
import { EventBus } from "@/events/event-bus";
import {
  getServiceDetails,
  getServiceDetailsByInquiryId,
  getBookingServicesDetailsByBookingId,
} from "@/modules/Services/api/services";
import { getLocationData } from "@/events/sharedMethods.js";

export default {
  name: "services",
  props: {
    value: [],
    serviceChanged: false,
    from: String,
    itemType: {
      default() {
        // can be booking or inquiry or invoice etc.
        return "booking";
      },
    },
    itemId: {
      default() {
        return null;
      },
    },
    viewPage: {
      default() {
        return false;
      },
    },
    duplicate: {
      default() {
        return false;
      },
    },
    // booking or inquiry or invoice id
    defaultFieldworker: {
      default() {
        return null;
      },
    },
    defaultEndDate: {
      default() {
        return null;
      },
    },
    defaultStartDate: {
      default() {
        return null;
      },
    },
    defaultStartTime: {
      default() {
        return null;
      },
    },
    companyId: {
      required: true,
    },
    loggedUser: {
      required: true,
    },
    dateFormat: {
      required: true,
    },
    timeFormat: {
      required: true,
    },
    giftStatus: null,
    currency: {
      default() {
        return {
          currency_acronym: "AUD",
          currency_fontAwsome: "fa fa-dollar",
          currency_id: 51,
          currency_name: "Australian dollar",
          currency_symbol: "$",
          currency_unicode: "f155",
          recognized_in_pdf: 1,
        };
      },
    },
    booking: null,
    bookingStatuses: {
      type: Array,
    },
    taxRatesOptions: [],
  },
  data() {
    return {
      services: this.value ?? [],
      isLoading: false,
      serviceRenderedCount: false,
      showUpperSelectServiceInput: 0,
      unsupportedServices: [],
      displayCopyDates: {
        showCopyDates: false,
        copyOnServiceLevel: false,
        serviceIdsWithClones: "",
      },
    };
  },
  computed: {
    isMobile() {
      return this.getWidth() < 460;
    },
    pricing() {
      let pricing = [];
      for (let service of this.services) {
        pricing.push({
          serviceId: service.service_id,
          serviceClone: service.clone,
          ...service.pricing,
        });
      }
      return pricing;
    },
  },
  methods: {
    getLocationData,
    onServiceMounted() {
      this.serviceRenderedCount++;
      if (this.serviceRenderedCount === this.services.length) {
        this.$emit("servicesMounted");
      }
    },
    confirm_delete_unspported_services() {
      EventBus.$emit(
        "onServiceRemoved1",
        this.unsupportedServices.service_id,
        this.unsupportedServices.clone
      );
      // Convert unsupportedServices to a set of strings for faster lookup and easy comparison
      const unsupportedSet = new Set(
        this.unsupportedServices.map((service) => JSON.stringify(service))
      );

      // Filter out unsupported services
      this.services = this.services.filter(
        (service) => !unsupportedSet.has(JSON.stringify(service))
      );

      console.log(this.services); // Output: [['Service1', 'A'], ['Service3', 'C']]
    },
    onAddressChanged() {
      for (let service of this.services) {
        window.servicesSelect.removeItem(service.service_id + "-47");
        service.serviceId = service.service_id;
        service.categoryId = parseInt(service.category_id);
        service.isCustom = parseInt(service.is_custom);
        EventBus.$emit("onServiceAdded", service);
      }
    },
    /**
     * this to be run when there is an item id and item type
     */
    initiativeRequest() {
      if (
        this.itemType !== "inquiry" &&
        this.itemId &&
        !this.booking.toEstimate
      ) {
        if (this.booking.services && this.booking.services.length > 0) {
          if (document.getElementById("booking-service-container")) {
            document.getElementById("booking-service-container").style.display =
              "block";
          }
          let servicesTmp = this.booking.services;
          servicesTmp.forEach((service) => {
            service.status_id = (this.booking.services || {}).status_id;
            service.collapsed = true;
            service.itemId = this.itemId;
            service.itemType = this.itemType;
            service.viewPage = this.viewPage;
            service.taxRatesOptions = this.taxRatesOptions;
            if (this.defaultStartDate) {
              service.defaultFieldworker = this.defaultFieldworker;
              service.defaultEndDate = this.defaultEndDate;
              service.defaultStartTime = this.defaultStartTime;
              service.defaultStartDate = this.defaultStartDate;
            }
            service.meta = this.booking?.meta;
          });

          // Step 2: Set the collapsed property of the last service to false.
          if (!this.viewPage) {
            if (servicesTmp.length > 0) {
              servicesTmp[servicesTmp.length - 1].collapsed = false;
            }
          }
          this.services = servicesTmp;
        } else {
          getBookingServicesDetailsByBookingId(
            this.itemId,
            this.companyId,
            1
          ).then((response) => {
            if (response.data.hasOwnProperty("result")) {
              if (document.getElementById("booking-service-container")) {
                document.getElementById(
                  "booking-service-container"
                ).style.display = "block";
              }
              let servicesTmp = (response.data.result || {}).services_details;
              if (Array.isArray(servicesTmp)) {

               servicesTmp.forEach((service) => {
                service.status_id = (response.data.result || {}).status_id;
                service.collapsed = true;
                service.itemId = this.itemId;
                service.itemType = this.itemType;
                service.viewPage = this.viewPage;
                service.taxRatesOptions = this.taxRatesOptions;

                if (this.defaultStartDate) {
                  service.defaultFieldworker = this.defaultFieldworker;
                  service.defaultEndDate = this.defaultEndDate;
                  service.defaultStartTime = this.defaultStartTime;
                  service.defaultStartDate = this.defaultStartDate;
                }
                service.meta = this.booking?.meta;
              });
              } else {
                console.log("services_details is not an array:", servicesTmp);
              }
              // Step 2: Set the collapsed property of the last service to false.
              if (!this.viewPage) {
                if (servicesTmp.length > 0) {
                  servicesTmp[servicesTmp.length - 1].collapsed = false;
                }
              }
              this.services = servicesTmp;
            }
          });
        }
      } else if (
        (this.itemType === "inquiry" && this.itemId) ||
        (this.itemType === "estimate" && this.itemId && this.booking.toEstimate)
      ) {
        let vm = this;

        getServiceDetailsByInquiryId(this.itemId, this.companyId, 1).then(
          (response) => {
            if (response.data.hasOwnProperty("result")) {
              if (document.getElementById("booking-service-container")) {
                document.getElementById(
                  "booking-service-container"
                ).style.display = "block";
              }
              let servicesTmp = (response.data.result || {}).services_details;
              if (Array.isArray(servicesTmp)) {

                servicesTmp.forEach((service) => {
                service.collapsed = true;
                service.itemId = this.itemId;
                service.itemType = this.itemType;
                service.viewPage = this.viewPage;
                service.taxRatesOptions = this.taxRatesOptions;
                if ((vm.defaultFieldworker || {}).user_id) {
                  service.defaultFieldworker = vm.defaultFieldworker;

                  service.contractor_id = vm.defaultFieldworker.user_id;
                  service.contractor_text =
                    vm.defaultFieldworker.contractor_text;
                  service.contractor_img = vm.defaultFieldworker.contractor_img;
                }
                service.meta = this.booking?.meta;
              });
            } else {
              console.log("services_details is not an array:", servicesTmp);
            }
              // Step 2: Set the collapsed property of the last service to false.
              if (!this.viewPage && servicesTmp.length > 0) {
                servicesTmp[servicesTmp.length - 1].collapsed = false;
              }
              this.services = servicesTmp;
            }
          }
        );
      }
    },
    /**
     /**
     * This holds all event listeners
     */
    addEventListeners() {
      // When a service has been selected from services dropdown
      EventBus.$on("onServiceAdded", (service) => {
        // save button position in view inquiry page
        $(".inquiry-save-btn").css("top", "52px");
        $(".inquiry-save-btn").css("right", "80px");

        this.isLoading = true;
        let locationData = this.getLocationData();

        getServiceDetails(
          [service.serviceId],
          this.companyId,
          service.categoryId,
          service.isCustom,
          1,
          locationData
        ).then((response) => {
          if (response.data.result && response.data.result.length > 0) {
            this.isLoading = false;
             let newService = response.data.result[0];
            // Lets first search for another service with the same id
            // let clone = this.services.filter(item => item.service_id == service.service_id).length
            // service.clone = Math.max(clone, 0)
            if (Array.isArray(this.services)) {
              newService.clone = this.services.filter(
                  (item) => item.service_id == newService.service_id
              ).length;

            }

            newService.pricing = {};
            newService.itemId = null;
            newService.itemType = null;
            if (document.getElementById("bookingStatus"))
              newService.status_id =
                document.getElementById("bookingStatus").value;
            newService.viewPage = this.viewPage;

            if (this.services.length === 0) {
              newService.defaultFieldworker = this.defaultFieldworker;
              newService.defaultEndDate = this.defaultEndDate;
              newService.defaultStartTime = this.defaultStartTime;
              newService.defaultStartDate = this.defaultStartDate;
            } else {
              var calculate_booking_duration_hours_val = 0;
              var calculate_booking_duration_minutes_val = 1;
              var target_server_to_control = this.services[this.services.length - 1];
              if (target_server_to_control?.calculate_booking_duration_hours) {
                calculate_booking_duration_hours_val =
                  target_server_to_control.calculate_booking_duration_hours;
              }
              if (target_server_to_control?.calculate_booking_duration_minutes) {
                calculate_booking_duration_minutes_val =
                  target_server_to_control.calculate_booking_duration_minutes;
              }
              var currentDate = new Date();
              currentDate.setHours(
                currentDate.getHours() + calculate_booking_duration_hours_val
              );
              currentDate.setMinutes(
                currentDate.getMinutes() +
                  calculate_booking_duration_minutes_val
              );
              newService.defaultStartTime =
                currentDate.getHours() + ":" + currentDate.getMinutes();
            }

            if (service.attributes && Array.isArray(service.attributes)) {
              // means location changed so get all attributes pricing for new location then update it by selected and value then return
              // Map each item in the newService.attributes array
              service.location_changed = true;
              service.attributes = service.attributes.map((attribute) => {
                // Find a matching attribute from service_attributes
                const match = newService.attributes.find(
                  (sa) => sa.attribute_id === attribute.attribute_id
                );
                if (match) {
                  // If found, copy all properties except unit_price from the matching attribute
                  return {
                    ...match,
                    selected: attribute.selected,
                    service_attribute_value: attribute.service_attribute_value,
                    value: attribute.value,
                  };
                }
                return attribute; // If no match, return the original attribute
              });
              EventBus.$emit(
                "onServiceCustomFieldSelected",
                service.service_id,
                service.clone
              );
              return;
            }
            newService.category_id = newService.service_category_id ?? 0;
            newService.service_name = newService.service_name.length
              ? newService.service_name
              : "Custom Service";
            newService.category_name = (newService.category_name || "").length
              ? newService.category_name
              : "Others";
            newService.taxRatesOptions = this.taxRatesOptions;
            if (this.itemId) {
              newService.add_from_edit = 1;
            }
            if (Array.isArray(this.services)) {
              this.services.forEach((service) => (service.collapsed = true));
              }
            newService.collapsed = false;
            this.services.push(newService);
            // Use Vue.nextTick to wait until the DOM updates
            this.$nextTick(() => {
              // Scroll to the newly added service
              let newServiceElement = document.getElementById(
                `service_checked_${newService.service_id}`
              );
              if (newService.clone) {
                newServiceElement = document.getElementById(
                  `service_checked_${newService.service_id}_${newService.clone}`
                );
              }
              if (newServiceElement) {
                newServiceElement.scrollIntoView({
                  behavior: "smooth",
                  block: "start",
                });
              }
            });
          }
        });

        $(this.$refs.services).sortable();
      });
      EventBus.$on("business-type-changed", (business_type) => {
        for (let service of this.services) {
          // Check if the service_location does not include the current business_type
          if (!service.service_location.includes(business_type)) {
            this.unsupportedServices.push(service); // Add the unsupported service to the array
            this.unsupportedServices.push(service); // Add the unsupported service to the array
          }
        }

        // If there are any unsupported services, log them or handle as needed
        if (this.unsupportedServices.length > 0 && !this.itemId) {
          $("#confirmDeleteServiceModal").modal("show"); // Show modal (might want to move outside the loop)

          console.log("Unsupported services:", this.unsupportedServices);
          console.log("Success"); // Log success or handle appropriately
        }
      });

      EventBus.$on("onServiceDuplicated", (service) => {
        let oldServiceId = service.service_id;
        let oldServiceClone = service.clone;
            if (Array.isArray(this.services)) {
              service.clone = this.services.filter(
          (item) => item.service_id == service.service_id  ).length;
        this.services.forEach((service) => (service.collapsed = true));
            }
        service.collapsed = false;
        this.services.push(service);
      });

      EventBus.$on("onServiceRemoved1", (serviceId, clone) => {
        let service = this.services.find(
          (item) => item.service_id == serviceId && item.clone == clone
        );
        this.services.splice(this.services.indexOf(service), 1);
      });

      EventBus.$on("onChangingPriceUpdated", ({ service, flags }) => {
        this.countServicePrice(service, flags);
      });
      EventBus.$on("onAddDeleteAppointment", () => {
        this.checkDisplayingCopyDates();
      });
    },
    countServicePrice(service, flags) {
      if (flags.considerMinimumPrice) {
        service.sub_total = 500;
      }
    },
    checkDisplayingCopyDates() {
      let countVisits = 0;

      for (let i = 0; i < this.services.length; i++) {
        if (this.services[i].visits) {
          countVisits += this.services[i].visits.length;
        }
      }
      let countServices = this.services.length;
      this.displayCopyDates.showCopyDates = countVisits > 1;
      this.displayCopyDates.copyOnServiceLevel = countServices > 1;

      let servicesWithClones = [];
      if (Array.isArray(this.services)) {

      this.services.forEach((service) => {
        servicesWithClones.push(service.service_id + "_" + service.clone);
      });
      }
      this.displayCopyDates.serviceIdsWithClones = servicesWithClones.join(",");
    },
    getWidth() {
      let xWidth = null;
      if (window.screen != null) xWidth = window.screen.availWidth;

      if (window.innerWidth != null) xWidth = window.innerWidth;

      if (document.body != null) xWidth = document.body.clientWidth;

      return xWidth;
    },
  },
  mounted() {
    window.onAddressChanged = this.onAddressChanged;
    this.addEventListeners();
    if (this.itemId) this.initiativeRequest();

    $(this.$refs.services).sortable({
      handle: ".drag-tool",
      cursor: "move",
    });
    EventBus.$on("onAddAnotherService", (isEdit) => {
      this.showUpperSelectServiceInput = 1;
      if (isEdit) {
        this.showUpperSelectServiceInput = 0;
      }
      this.showAddServiceButton = 0;
    });
  },
  beforeDestroy() {
    delete window.onAddressChanged;
  },
  // updated() {
  //     document.querySelectorAll('.add-icon').forEach(function(element) {
  //
  //         element.addEventListener('click', function(event) {
  //             if (typeof window.enableEditing ==='function'){
  //                 window.enableEditing();
  //             }
  //             // Execute the pre-modal function
  //
  //
  //             // Now continue with the default behavior, which is to open the modal
  //             // Assuming you are using Bootstrap modal, it should automatically open
  //             // due to the 'data-toggle' and 'data-target' attributes
  //         });
  //     });
  // },
  watch: {
    pricing: {
      handler: function (value, oldValue) {
        if (JSON.stringify(oldValue) != JSON.stringify(value)) {
          EventBus.$emit("onPricesUpdated", value);
        }
      },
      deep: true,
    },
    services: {
      handler: function (newValue, oldValue) {
        this.$emit("input", newValue);
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.ibox-style {
  padding-top: 0px !important;
  margin-top: -22px !important;
}

.view-container {
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}

@media (max-width: 991px) {
  .ibox-style {
    margin-top: 0 !important;
  }
}
</style>
